import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
const { Title } = Typography;

export default function AssignedHeader({ totalItem }) {
  const { t } = useTranslation('Vindoc');

  return (
    <div className="flex min-h-12 items-center justify-between border-b border-gray-800 pb-3">
      <Title level={4} className="m-0">
        {t('Assigned List')}
        <span className="ml-1">
          ({totalItem || 0} {t('items')})
        </span>
      </Title>
    </div>
  );
}
